<template>
	<div class="chat-helper-container">
		<div class="chat-helper-steps">
			<div class="chat-helper-step" :class="{'chat-helper-step-active':step.index == '1'}">
				<span class="chat-helper-step-num">1</span>
				<span>好友选择</span>
			</div>
			<div class="chat-helper-s-line"></div>
			<div class="chat-helper-step" :class="{'chat-helper-step-active':step.index == '2'}">
				<span class="chat-helper-step-num">2</span>
				<span>一键群发</span>
			</div>
			<div class="chat-helper-s-line"></div>
			<div class="chat-helper-step" :class="{'chat-helper-step-active':step.index == '3'}">
				<span class="chat-helper-step-num">3</span>
				<span>群发状态</span>
			</div>
		</div>
		<div class="chat-helper-box">
			<keep-alive>
				<components 
					@sender-fans-call = 'senderFansCall($event)'
					@sender-msg-call = 'senderMsgCall($event)'
					@re-set-task = "reSetTask($event)"
					:fans = "fans"
					:msgOpt = 'msgOpt'
					:is="step.comp"
					:ref="'childHelper'+step.index">
				</components>
			</keep-alive>
		</div>
		<div class="chat-helper-nav">
			<button @click="prev" v-if="step.prev != ''">{{step.prev}}</button>
			<button @click="next" v-if="step.next != ''">{{step.next}}</button>
		</div>
	</div>
</template>

<script>
	import ChatHelperStepOne from './ChatHelperStepOne.vue'
	import ChatHelperStepTwo from './ChatHelperStepTwo.vue'
	import ChatHelperStepThree from './ChatHelperStepThree.vue'
	
	export default{
		name:'ChatHelperHome',
		components:{
			ChatHelperStepOne,
			ChatHelperStepTwo,
			ChatHelperStepThree
		},
		data(){
			return{
				cacheFansKey: 'ChatHelperFansList',  // 缓存的任务粉丝列表key
				cacheOptKey: 'ChatHelperMsgOpt',         // 缓存的任务选项
				// 切换组件集合，用于上下步切换
				comps:['ChatHelperStepOne','ChatHelperStepTwo','ChatHelperStepThree'],
				// 当前所在步骤
				step:{
					index: 1,
					comp: 'ChatHelperStepOne',
					prev:'上一页',
					next:'下一页'
				},
				// 群发数据
				fans:[],
				msgOpt:{}
			}
		},
		methods:{
			// 初始化数据
			init(){
				this.step = {
					index: 1,
					comp: 'ChatHelperStepOne',
					prev:'上一页',
					next:'下一页'
				}
				this.fans = []
				this.msgOpt = {}
			},
			
			// 上一步
			prev(){
				let index = this.step.index -1
				if(index < 1){
					index = 1
				}
				this.step.index = index
				this.step.comp = this.comps[index-1]
			},
			
			// 下一步
			next(){
				let index = this.step.index +1
				if(index > 3){
					index = 3
				}
				// 如果是第二补，判断粉丝是否未空
				if(index == 2){
					if(this.fans.length === 0){
						CHAT_LAYER.msg('请选择粉丝！')
						return
					}
				}else if(index == 3){
					if(this.msgOpt.msgList === undefined || this.msgOpt.msgList.length === 0){
						CHAT_LAYER.msg('请输入群发消息，或设置群发选项！')
						return
					}
				}
				// 如果是最后一步，添加提示框提示
				if(index == 3){
					let msgInfo =  this.msgCounterInfo(this.msgOpt.msgList)
					let _this = this
					let content = ""
					if(this.msgOpt.fansGroupOpen){
						content += '客服并发：<span style="color:green;font-weight: bold;">开启</span><br/>'
					}else{
						content += '客服并发：<span style="color:red;font-weight: bold;">关闭</span><br/>'
					}
					if(this.msgOpt.sendType == 1){
						content += '群发类型：以消息为单位发送<br/>'
					}else{
						content += '群发类型：以好友为单位发送<br/>'
					}
					content += '好友数：'+ this.fans.length +'<br/>'
					content += '消息分组数：'+msgInfo.groupCount+'，消息数：'+ msgInfo.msgCount +'<br/>'
					content += '好友时间间隔：'+ this.msgOpt.fansMinTime + '-' + this.msgOpt.fansMaxTime +'<br/>'
					content += '好友消息间隔：'+ this.msgOpt.msgMinTime + '-' + this.msgOpt.msgMaxTime +'<br/>'
					content += '确定按照以上参数群发吗？'
					CHAT_LAYER.open({
					  content: content
					  ,btn: ['确认', '取消']
					  ,yes: function(index2, layero){
					    _this.step.index = index
						_this.step.comp = _this.comps[index-1]
					    _this.step.prev  = ''
					    _this.step.next = ''
					    _this.$nextTick(()=>{
					    	_this.$refs.childHelper3.start()
							CHAT_LAYER.close(index2)
					    })	
					  }
					  ,btn2: function(index, layero){
					    //按钮【按钮二】的回调
					    //return false 开启该代码可禁止点击该按钮关闭
					  }
					  ,cancel: function(){ 
					    //右上角关闭回调
					    //return false 开启该代码可禁止点击该按钮关闭
					  }
					})	
				}else{
					this.step.index = index
					this.step.comp = this.comps[index-1]
				}
			},
			
			// 粉丝选择页面的数据回调
			senderFansCall(data){
				this.fans = data
			},
			
			// 消息发送页面的数据回调
			senderMsgCall(data){
				this.msgOpt = data
			},
			
			// 重新设定任务回调
			reSetTask(){
				this.init()
				this.$nextTick(()=>{
					this.$refs.childHelper1.init()
				})			
			},
			
			// 查看是否有任务，如果有，则停留再任务状态页面
			hasTask(){
				let friendList = localStorage.getItem(this.cacheFansKey)
				let sendOpt = localStorage.getItem(this.cacheOptKey)
				if(friendList !== null && sendOpt !== null){
					let index = 3
					this.step.index = index
					this.step.comp = this.comps[index-1]
					this.step.prev  = ''
					this.step.next = ''
				}
			},
			
			// 计算消息数据
			msgCounterInfo(msgList){
				let msgCount = 0
				let groupCount = 0
				for(let i in msgList){
					groupCount++
					for (var j = 0; j < msgList[i].length; j++) {
						msgCount++
					}
				}
				return {
					msgCount,
					groupCount
				}
			}
		},
		created() {
			this.hasTask()
		},
		activated() {
			this.hasTask()
		}
	}
</script>

<style>
	.chat-helper-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.chat-helper-container .chat-helper-steps{
		padding: 10px 20px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-weight: 600;
	}
	.chat-helper-steps .chat-helper-step{
		padding: 0 10px;
	}
	.chat-helper-steps .chat-helper-step-active{
		color: #42B983;
	}
	.chat-helper-step-active > .chat-helper-step-num{
		border: 1px solid #42B983 !important;
	}
	.chat-helper-step span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-helper-step .chat-helper-step-num{
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border: 1px solid #CCCCCC;
		border-radius: 50%;
		margin-right: 5px;
	}
	.chat-helper-steps .chat-helper-s-line{
		width: 50px;
		height: 1px;
		background-color: #666666;
	}
	.chat-helper-container .chat-helper-box{
		position: absolute;
		top: 70px;
		left: 0;
		right: 0;
		bottom: 50px;
		padding: 0 20px;
	}
	.chat-helper-container .chat-helper-nav{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 50px;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chat-helper-nav button{
		display: block;
		margin: 0 10px;
		background-color: #42B983;
		color: #FFFFFF;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		border-radius: 2px;
		cursor: pointer;
	}
</style>
